import { FC, useContext, useEffect, useRef, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import useDataInitializer from "../../hooks/useDataInitializer";
import useIdentity from "../../hooks/useIdentity";
import { useI18n } from "../../hooks/useTranslations";
import { useMeApi } from "../../http/me/api";
import Header from "../ui/Header";
import Panel from "../ui/Panel";
import MyProfileForm, { MyProfileFormBody } from "./MyProfileForm";

const MyProfile: FC = () => {
  const meApi = useMeApi();
  const identity = useIdentity();
  const i18n = useI18n();
  const aborter = useRef(new AbortController());
  const dispatch = useContext(NotificationDispatch);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data, error } = meApi.useSettings(aborter.current.signal, identity?.email);
  const [settings, isInitialized] = useDataInitializer(data, error);

  useEffect(() => {
    error && dispatch(showErrorNotification(i18n, error));
  }, [error]);

  const onSubmit = async (formBody: MyProfileFormBody) => {
    setIsSubmitting(true);
    const mutateCache =
      formBody.language.value != i18n.language ||
      (formBody.measurmentType.value === "imperial") !== !!data?.me.distanceInMiles;
    try {
      await meApi.updateMyProfie(
        {
          distanceInMiles: formBody.measurmentType?.value === "imperial",
          drivingLicenseExpiration: formBody.drivingLicenseExpiration,
          language: formBody.language.value,
        },
        mutateCache,
      );

      mutateCache && i18n.setLanguage(formBody.language.value);
      dispatch(showSuccessNotification(i18n.t));
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header title={i18n.t.common.myProfile} />
      <Panel>
        <MyProfileForm isDisabled={isSubmitting} isLoading={!isInitialized} onSubmit={onSubmit} user={settings?.me} />
      </Panel>
    </>
  );
};

export default MyProfile;
